"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownWrapper = exports.DropdownTrigger = exports.Dropdown = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var DropdownWrapper = exports.DropdownWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__DropdownWrapper",
  componentId: "sc-18xqfs8-0"
})(["position:relative;display:inline-block;width:", ";"], function (_ref) {
  var width = _ref.width;
  return width ? "".concat(width, "px;") : '100%';
});
var DropdownTrigger = exports.DropdownTrigger = _styledComponents["default"].div.withConfig({
  displayName: "styles__DropdownTrigger",
  componentId: "sc-18xqfs8-1"
})([""]);
var Dropdown = exports.Dropdown = _styledComponents["default"].div.withConfig({
  displayName: "styles__Dropdown",
  componentId: "sc-18xqfs8-2"
})(["position:absolute;background:white;max-height:0;height:0;opacity:0;overflow:hidden;width:100%;top:100%;border:1px solid ", ";border-radius:0 0 4px 4px;transition:all 0.1s ease-in-out;", ""], _palette.commonPalette.borderGrey, function (p) {
  return p.open && "\n    opacity: 1;\n    max-height: 250px;\n    height: auto;\n    z-index: 3;\n    transition: all 0.1s ease-in-out;\n  ";
});
//# sourceMappingURL=styles.js.map